(function($, App, Utils, Components) {
  'use strict';

  Components.create('CustomRange', {
    Selectors: {
      main: '.js-range'
    },

    bindEvents: function() {
      Components.CustomRange.customrange.noUiSlider.on('change', (values, handle, unencoded, tap, positions) => {
        Components.trigger('customrange:change', [{ sliderValues: values }]);
        if(Components.CustomRange.boundElement) {
            Components.CustomRange.boundElement.val(values[values.length - 1])
        }
      });
    },

    init: function() {
      if ($(Components.CustomRange.Selectors.main).length > 0) {
        const data = Utils.jsonDA($(Components.CustomRange.Selectors.main), 'customrange');
        let start = data && data.start ? data.start.split(',') : false;
        let count = start ? start.length : 1;

        const opts = {
          start: start ? start.map(s => Number(s)) : [0],
          connect: data && data.connect ? data.connect : [...Array(count + 1)].map((c, i) => ((count - i) % 2 !== 0)),
          step: data && data.step ? Number(data.step) : 1,
          range: {
            min: data && data.rangemin ? Number(data.rangemin) : 0,
            max: data && data.rangemax ? Number(data.rangemax) : 1000
          },
          format: wNumb({
            decimals: 0
          }),
          tooltips: [...Array(count)].map(x => wNumb({ decimals: 0}))
        };

        Components.CustomRange.customrange = document.querySelector(Components.CustomRange.Selectors.main);
        noUiSlider.create(Components.CustomRange.customrange, opts);

        Components.CustomRange.boundElement = $(data.bindto);

        if(Components.CustomRange.boundElement)
        {
            Components.CustomRange.boundElement.on('keyup', function(){
                Components.CustomRange.customrange.noUiSlider.set([null, $(this).val()]);
            });
        }
        Components.CustomRange.bindEvents();
      }
    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);
